import type { Theme } from "@/v1-console/theme/theme.types"
import ThemeSwitcher, { type ThemeSwitcherProps } from "@/v1-console/theme/ThemeSwitcher"
import { trackThemeFromUser, trackThemeLogged }
  from "@/v1-console/theme/theme.tracking"

type ThemeSwitcherWithTrackingProps = Omit<ThemeSwitcherProps, "onMount" | "onChange">

function ThemeSwitcherWithTracking(
  props: ThemeSwitcherWithTrackingProps
) {
  return (
    <ThemeSwitcher
      onMount={(theme: Theme) => {
        trackThemeLogged(theme.name)
      }}
      onChange={(theme: Theme) => {
        trackThemeFromUser(theme.name)
      }}
      {...props}
    />
  )
}

export default ThemeSwitcherWithTracking
